import { Expose, Type } from 'class-transformer';
import { YearlyTestRecordResponseDto } from './yearly-test-record.response.dto';

export class ConfirmatoryTestingScheduleResponseDto {
    /**
     * Unique identifier for the schedule
     * @example 'a1b2c3d4-e5f6-7890-1234-567890abcdef'
     */
    @Expose()
    id: string;

    /**
     * Reference to product in MPD
     * @example 'a1b2c3d4-e5f6-7890-1234-567890abcdef'
     */
    @Expose()
    productId: string;

    /**
     * Product number
     * @example '100487'
     */
    @Expose()
    productNumber: string;

    /**
     * Product brand and name
     * @example 'Zepzelca Lurbinectedin for injection, 4mg per vial'
     */
    @Expose()
    productBrandName: string;

    /**
     * Drug Identification Number
     * @example '02520834'
     */
    @Expose()
    din?: string;

    /**
     * Natural Product Number
     * @example '80025550'
     */
    @Expose()
    npn?: string;

    /**
     * Fabricator information (optional)
     * @example 'Baxter Oncology, Germany'
     */
    @Expose()
    fabricator?: string;

    /**
     * Product size (optional)
     * @example '30ml vial'
     */
    @Expose()
    size?: string;

    /**
     * Dosage form (optional)
     * @example 'Powder (Sterile) For IV injection, by infusion.'
     */
    @Expose()
    dosageForm?: string;

    /**
     * Quantity for full test (optional)
     * @example '60 vials'
     */
    @Expose()
    qtyForFullTest?: string;

    /**
     * Yearly test records
     */
    @Expose()
    @Type(() => YearlyTestRecordResponseDto)
    yearlyTests: YearlyTestRecordResponseDto[];

    /**
     * Whether this schedule is active
     * If false, product doesn't require annual confirmatory testing
     * @example true
     */
    @Expose()
    isActive: boolean;

    /**
     * Reason for disabling the schedule (if isActive is false)
     * @example 'Product exempt from annual testing per regulatory guidance'
     */
    @Expose()
    disabledReason?: string;

    /**
     * User who created this record
     * @example 'John Smith'
     */
    @Expose()
    createdBy: string;

    /**
     * User who last updated this record
     * @example 'Jane Doe'
     */
    @Expose()
    lastUpdatedBy: string;

    /**
     * Timestamp when the record was created
     * @example '2024-01-15T10:30:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    createdAt: Date;

    /**
     * Timestamp when the record was last updated
     * @example '2024-01-15T15:45:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    updatedAt: Date;
}

